import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';

import { requestPasswordReset } from '../../services/authService';
import '../Login/Login.css';
import './ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      setErrorMessage('E-mail is required.');
      return;
    }

    if (!isEmail(normalizedEmail)) {
      setErrorMessage('Enter a valid e-mail address.');
      return;
    }

    setErrorMessage('');
    setIsSubmitting(true);

    try {
      await requestPasswordReset(normalizedEmail);
      setIsSubmitted(true);
    } catch {
      setErrorMessage('Unable to process the request. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <main className="loginPage">
        <section
          className="loginCard forgotPasswordSuccess"
          aria-labelledby="forgot-password-success-title"
        >
          <h1 id="forgot-password-success-title">Check your email</h1>
          <p>
            If an account with this email exists, a password reset link has
            been sent.
          </p>
          <p>The link expires in 1 hour.</p>
          <button
            className="loginSubmitButton forgotPasswordButton"
            type="button"
            onClick={() => navigate('/login')}
          >
            Go to Sign In
          </button>
        </section>
      </main>
    );
  }

  return (
    <main className="loginPage">
      <section className="loginCard" aria-labelledby="forgot-password-title">
        <h1 id="forgot-password-title">Forgot password</h1>
        <form
          className="loginForm"
          onSubmit={handleSubmit}
          aria-busy={isSubmitting}
          noValidate
        >
          <div className="loginField">
            <label htmlFor="forgot-password-email">E-mail</label>
            <input
              id="forgot-password-email"
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="name@example.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              aria-invalid={Boolean(errorMessage)}
              disabled={isSubmitting}
            />
          </div>
          {errorMessage && (
            <p className="loginError" role="alert">
              {errorMessage}
            </p>
          )}
          <button
            className="loginSubmitButton"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending reset link...' : 'Send reset link'}
          </button>
        </form>
        <p className="loginRegisterText">
          <Link to="/login">Back to Sign In</Link>
        </p>
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
